export const FETCH_MIX_API = "FETCH_MIX_API";
export const FETCH_MIX_API_PENDING = "FETCH_MIX_API_PENDING";
export const FETCH_MIX_API_REJECTED = "FETCH_MIX_API_REJECTED";
export const FETCH_MIX_API_FULFILLED = "FETCH_MIX_API_FULFILLED";
